module.exports = __webpack_public_path__ + "static/media/selection_disneyplus.a18e6637.png";